import { Link } from 'react-router-dom';

export default function ArticleBanner() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20bright%20airy%20workspace%20with%20a%20macbook%20displaying%20colorful%20spreadsheet%20charts%20surrounded%20by%20fashion%20lookbooks%20a%20ceramic%20coffee%20mug%20and%20small%20shopping%20parcels%20tied%20with%20string%20on%20a%20light%20oak%20desk%20afternoon%20sunlight%20pouring%20through%20sheer%20curtains%20editorial%20photography%20with%20warm%20cream%20and%20beige%20tones&width=1600&height=600&seq=article-banner-v2&orientation=landscape"
          alt="Sugargoo Spreadsheet guide and research workspace"
          title="Sugargoo Spreadsheet Complete Guide"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/35 via-black/20 to-black/35"></div>
      </div>
      <div className="relative z-10 max-w-3xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-white mb-4">
          Want to Learn More About Sugargoo Spreadsheet?
        </h2>
        <p className="text-white/85 text-sm md:text-base mb-6">
          Read our comprehensive guide covering everything from getting started to advanced shopping strategies.
        </p>
        <Link
          to="/sugargoo-spreadsheet-guide"
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          className="inline-flex items-center gap-2 px-7 py-3.5 bg-accent-500 text-white font-semibold text-sm rounded-full hover:bg-accent-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
        >
          <i className="ri-book-read-line"></i>
          Read the Complete Guide
        </Link>
      </div>
    </section>
  );
}